import { render } from "./FeeDetailView.vue?vue&type=template&id=7f88dc68"
import script from "./FeeDetailView.vue?vue&type=script&lang=js"
export * from "./FeeDetailView.vue?vue&type=script&lang=js"

import "./FeeDetailView.vue?vue&type=style&index=0&id=7f88dc68&lang=css"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__